export default __webpack_public_path__ + "static/filters-55b2aa957de7f5d7970fd39bb102f900.svg";